import TariffBuy from './TariffBuyContainer.vue';

export { TariffBuy };



// WEBPACK FOOTER //
// ./src/modules/home/tariffBuy/index.js